module.exports = __webpack_public_path__ + "img/peter_n.3363ba76.png";